// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { ON_MY_MATCH_TOGGLE_TRANSITION_DURATION } from '../../constants/ui/mymatch';
import theme from '../../styled-components/dark';
import { Card } from '../../styled-components/dark/common';
import colors from '../../styled-components/palette';
import { MatchViewModes, type MatchViewMode } from '../../types/matchView';
import BetGroupOutcomeContainer from '../BetGroupOutcome/BetGroupOutcomeContainer';
import MyMatchDynamicBackground, {
  MyMatchDynamicBackgroundLeftImgClassName,
  MyMatchDynamicBackgroundRadialClassName,
} from '../MyMatchDynamicBackground';

const MatchHotBetGroupOutcomeStyles = {
  betNameColor: colors.bluegrey250,
  outcomeNameColor: colors.white,
};

const Wrapper = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 1em;
  padding: 0.5em 1em;
  border-radius: ${Card.borderRadius};

  transform-style: preserve-3d;
`;

const LabelsWithSeparator = styled.div`
  display: flex;
  align-items: center;
  flex: 1 1 0%;
`;

const Labels = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const Betname = styled.span`
  color: ${MatchHotBetGroupOutcomeStyles.betNameColor};
`;

const OutcomeName = styled.span`
  color: ${MatchHotBetGroupOutcomeStyles.outcomeNameColor};
`;

const Separator = styled.div`
  flex-grow: 1;
  min-width: 1em;
  height: 1px;
  margin: 0 0.6em;
  transition: background-color ${ON_MY_MATCH_TOGGLE_TRANSITION_DURATION}ms ease-in-out;

  ${({ $matchViewMode }) => css`
    ${$matchViewMode === MatchViewModes.MY_MATCH
      ? css`
          background-color: rgba(255, 255, 255, 0.1);
        `
      : css`
          background-color: rgb(51, 51, 51);
        `}
  `}
`;

const StyledBetGroupOutcomeContainer = styled(BetGroupOutcomeContainer)`
  width: 6em;
`;

const StyledMyMatchDynamicBackground = styled(MyMatchDynamicBackground)`
  --MyMatchDynamicBackground-defaultBackgroundColor: var(
    --MatchToolbar-dynamicDefaultBackgroundColor,
    ${theme.MatchBetGroup.backgroundColor}
  );

  z-index: -1;

  & .${MyMatchDynamicBackgroundLeftImgClassName} {
    height: 500%;
    top: -8em;
    left: -3em;
  }

  & .${MyMatchDynamicBackgroundRadialClassName} {
    left: 0%;
    top: -9.5em;
    width: 400%;
  }
`;
type MatchHotBetGroupOutcomeProps = {
  className?: string;
  outcomeName: string;
  betName: string;
  matchViewMode: MatchViewMode;
};

const MatchHotBetGroupOutcome = ({
  className = '',
  outcomeName,
  betName,
  matchViewMode,
}: MatchHotBetGroupOutcomeProps) => {
  return (
    <Wrapper className={className}>
      <StyledMyMatchDynamicBackground isActive={matchViewMode === MatchViewModes.MY_MATCH} />

      <LabelsWithSeparator>
        <Labels>
          <Betname>{betName}</Betname>
          <OutcomeName>{outcomeName}</OutcomeName>
        </Labels>
        <Separator $matchViewMode={matchViewMode} />
      </LabelsWithSeparator>
      <StyledBetGroupOutcomeContainer showPercentDistribution={false} noLabel />
    </Wrapper>
  );
};

export default MatchHotBetGroupOutcome;
